<template>
  <article class="category flex flex-col">
    <h1 class="mb-[24px] font-roboto text-[32px] font-medium leading-6">
      Учителю и ученику
    </h1>
    <div
      class="mb-8 h-auto rounded-xl px-6 pb-4 pt-6 text-[14px] leading-[22px] shadow-drop-0 transition-all duration-500"
    >
      <div class="flex">
        <div>
          <div
            class="font-roboto"
            :class="[
              isShowMore && isNotMobile ? 'text-[16px] font-medium' : '',
            ]"
          >
            В разделе «Учителю и ученику» представлены:
          </div>
          <ul>
            <li>
              - материалы по истории для школьного курса «История России» и
              «Всеобщая история» с 5 по 11 класс, структурированные по главам и
              параграфам единой линейки учебников с учетом Федеральных
              государственных образовательных стандартов (ФГОС);
              <span
                v-show="!isShowMore"
                class="ml-1 cursor-pointer select-none text-[#004AA1]"
                @click="isShowMore = true"
              >
                Подробнее...
              </span>
            </li>
            <li v-show="isShowMore">
              - дополнительные материалы для преподавателей и студентов системы
              среднего профессионального образования в соответствии с учебниками
              истории для СПО;
            </li>
            <li v-show="isShowMore">
              - статьи, лекции и интервью историков, публицистов и журналистов,
              дополненные профессиональными и архивными фото- и видео-
              материалами.
            </li>
          </ul>
          <div v-show="isShowMore" class="mt-2">
            Ресурс незаменим для саморазвития и при подготовке к ВПР, ОГЭ, ЕГЭ и
            вступительным испытаниям, а также позволяет подготовиться учителю и
            ученику по любой из тем школьной программы, использовать достоверные
            материалы на уроках, в докладах и презентациях. Тесты к каждому
            разделу помогают проверить знания и могут быть использованы на
            уроках и во внеурочной работе по историческому просвещению.
          </div>
          <div v-show="isShowMore" class="mt-4">
            Раздел «Учителю и ученику» основан на материалах Российского
            военно-исторического общества, Общества «Знание», образовательной
            медиатеки «Лекторий «Достоевский» и других партнеров.
          </div>
        </div>
      </div>
      <div
        v-show="isShowMore"
        class="mb-2 mt-4 cursor-pointer select-none text-[#004AA1]"
        @click="isShowMore = false"
      >
        Свернуть
      </div>
    </div>
    <TeacherShelf
      v-for="(shelf, idx) in sortedData"
      :key="`title_${shelf.name}`"
      :shelf="shelf"
      :index="idx"
    />

    <TeacherProjectBlock :data="projects" class="mt-2" />

    <!-- <GameBanner class="mt-16" /> -->

    <TeacherThePartnersBanner class="mt-16" />
  </article>
</template>

<script setup>
import projects from '@/assets/data/projects';

const { teachersCategory } = useTeachersCategory();
const data = computed(() => teachersCategory.data?.value);
const { isNotMobile } = useBreakpoint();

const isShowMore = ref(false);

const sortedData = computed(() => {
  return data.value
    ?.filter(({ id }) => [1, 2, 4].includes(id)) // TODO захардкодил фильтр чтобы не видели новые полки
    ?.filter(({ subjects }) => subjects?.length)
    ?.map((shelf) => {
      return {
        ...shelf,
        subjects: [...shelf.subjects].sort((a, b) =>
          parseInt(a.school_class?.title) > parseInt(b.school_class?.title)
            ? -1
            : 1,
        ),
      };
    });
});

useHead({
  title:
    'История РФ: Учителю и ученику | Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      name: 'keywords',
      content: 'История РФ: статьи для школьников и студентов',
    },
  ],
});
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin-block-start: 8px;
  margin-block-end: 8px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
  unicode-bidi: isolate;
}
</style>
